<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">
          Cameras
        </h3>
      </div>
      <div class="card-body">
        <div
          v-if="cameras.length === 0"
          class="empty"
        >
          No cameras found
        </div>
        <button
          v-for="camera in cameras"
          :key="camera.deviceId"
          :title="formatName(camera.label)"
          class="btn btn-space"
          :class="{
            'btn-secondary': camera.deviceId != activeCameraId,
            'btn-primary': camera.deviceId == activeCameraId
          }"
          v-on="{ click: camera.deviceId != activeCameraId ? () => selectCamera(camera) : () => {} }"
        >
          {{ formatName(camera.label) }}
        </button>
      </div>
    </div>

    <div class="card">
      <div class="preview-container">
        <video
          id="preview"
          class="card-img-top"
        />
      </div>
      <div class="card-body d-flex flex-column">
        <h4>Scans</h4>
        <div class="text-muted">
          <ul v-if="scans.length === 0">
            <li class="empty">
              No scans yet
            </li>
          </ul>
          <transition-group
            name="scans"
            tag="ul"
          >
            <li
              v-for="item in scans"
              :key="item.date"
              :title="item.content"
            >
              {{ item.content }}
            </li>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css">
.preview-container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    overflow: hidden;
}
</style>


<script>
/* eslint-disable no-console */
import 'webrtc-adapter'
import { BrowserQRCodeReader } from '@zxing/library'

import enterSound from '@/assets/enter.wav'
import errorSound from '@/assets/enter.wav'

export default {
    name: 'Entry',
    data: () => ({
        scanner: null,
        activeCameraId: null,
        cameras: [],
        scans: [],
        timeoutHandler: null,
        sounds: {
            enter: new Audio(enterSound),
            error: new Audio(errorSound),
        },
    }),
    mounted: function() {
        this.scanner = new BrowserQRCodeReader()
        this.scanner
            .getVideoInputDevices()
            .then(cameras => {
                this.cameras = cameras
                if (cameras.length > 0) {
                    this.activeCameraId = cameras[0].deviceId
                    this.scan(
                        this.activeCameraId,
                        'preview',
                        this.onSuccess,
                        this.onError
                    )
                } else {
                    console.error('No cameras found.')
                }
            })
            .catch(err => console.error(err))
    },
    methods: {
        formatName: function(name) {
            return name || '(unknown)'
        },
        selectCamera: function(camera) {
            if (!camera) return

            this.activeCameraId = camera.deviceId
            this.scan(
                this.activeCameraId,
                'preview',
                this.onSuccess,
                this.onError
            )
        },
        scan: function(deviceId, videoElement, onSuccess, onError) {
            this.scanner
                .decodeFromInputVideoDevice(deviceId, videoElement)
                .then(result => {
                    onSuccess(result)
                    this.scan(deviceId, videoElement, onSuccess, onError)
                })
                .catch(error => onError(error))
        },
        onSuccess: function(result) {
            this.sounds.enter.play()
            this.scans.unshift({
                date: +Date.now(),
                content: result.text,
            })
        },
        onError: function(error) {
            this.sounds.error.play()
            console.error(error)
        },
    },
}
</script>
